import { t, useI18n } from "@bookingcom/lingojs-react";
import { FlightBadgeVariant } from "@flights/types";
import { useMemo } from "react";
const useFlightCardBadgesListController = (flight) => {
    const i18n = useI18n();
    const badgesStyles = {
        flexibleTicket: {
            key: "flexibleTicket",
            style: FlightBadgeVariant.CONSTRUCTIVE,
            alternative: true,
            text: i18n.trans(t("flights_apex_sr_flex_badge"))
        },
        appleCardBenefits: {
            key: "appleCardBenefits",
            style: FlightBadgeVariant.CALLOUT,
            alternative: true,
            text: i18n.trans(t("apple_rewards_flights_sr_badge_title")),
            flightToken: flight.token
        }
    };
    return useMemo(() => {
        const list = flight.badges?.map(({ text, variant, type }, i) => ({
            key: text + i,
            text,
            style: variant,
            alternative: true,
            type,
            flightToken: flight.token
        })) || [];
        if (flight.ancillaries?.flexibleTicket) {
            list.push(badgesStyles.flexibleTicket);
        }
        if (flight.hasAppleCardBenefits) {
            list.push(badgesStyles.appleCardBenefits);
        }
        return list;
    }, [
        badgesStyles.appleCardBenefits,
        badgesStyles.flexibleTicket,
        flight.ancillaries?.flexibleTicket,
        flight.badges,
        flight.hasAppleCardBenefits,
        flight.token
    ]);
};
export default useFlightCardBadgesListController;
